import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-actemplate',
  templateUrl: './view-actemplate.component.html',
  styleUrls: ['./view-actemplate.component.scss']
})
export class ViewActemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
